import { lazy } from 'react';

import type { Policy } from '@cartwhl/common/appletPolicy';

import type { AppletDefinition } from '../../applets';

const AdminAssetUploadRoute = lazy(() => import('./AdminAssetUploadRoute'));

const applet = {
  id: 'admin-asset-upload',
  path: '/admin-asset-upload',
  paths: ['/admin-asset-upload'],
  label: 'Admin Asset Upload',
  description: 'Upload images and videos for blog and website.',
  dashboard: {
    title: 'Admin Asset Upload',
    description: 'Upload images and videos for blog and website.',
    order: 80,
  },
  policy: {
    requiresLoggedIn: true,
    requiresAdmin: true,
  } satisfies Policy,
  component: AdminAssetUploadRoute,
} satisfies AppletDefinition;

export default applet;
